module.exports = __webpack_public_path__ + "media/components/GoogleMap/common/MultiContainer/close-899730db0992ce018996c5a285239888.svg";